import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import './RangeSlider.scss';

export class RangeSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      original: 0,
      ghost: 100,
      range: [0, 100],
      error: false,
      sliderTimer: null
    };
  }

  componentDidMount() {
    const { min, max, range } = this.props;
    this.setState({
      original: range && range.length ? range[0] : min,
      ghost: range && range.length ? range[1] : max,
      range: range ? range : [min, max]
    });
  }

  handleSliderChange(slider, e, v) {
    const { min, max } = this.props;
    let newState = { ...this.state };
    newState[slider] = Number(e.target.value);

    if (slider === 'original' && Number(e.target.value) > max - 3) {
      newState[slider] = max - 3;
    }

    if (slider === 'ghost' && Number(e.target.value) < min + 3) {
      newState[slider] = min + 3;
    }

    newState.range = [newState.original, newState.ghost].sort((a, b) => a - b);
    this.handleUpdateState(newState, slider);

    // only update data filter if slider stops moving for 1s
    clearTimeout(this.state.sliderTimer);
    this.setState({
      sliderTimer: setTimeout(() => {
        //only send the last slider value after 1s
        this.handleUpdateDataFilter();
      }, 1000)
    });
  }

  handleUpdateState(newState, slider) {
    const { range } = newState;
    const difference = range[1] - range[0];
    if (difference < 3) {
      if (slider === 'original') {
        newState.ghost = newState.original + 3;
        newState.range = [newState.original, newState.ghost];
      } else {
        newState.original = newState.ghost - 3;
        newState.range = [newState.original, newState.ghost];
      }
    }
    this.setState(newState);
  }

  handleUpdateDataFilter() {
    const { min, max } = this.props;
    const rangeStart = this.state.range[0] !== min ? this.state.range[0] : null;
    const rangeEnd = this.state.range[1] !== max ? this.state.range[1] : null;
    this.props.actions.updateDataFilter({
      rangeStart,
      rangeEnd
    });
  }

  render() {
    const { min, max } = this.props;
    return (
      <div className="range-slider-container slds-form-element">
        <span className="range-slider-label slds-form-element__label">
          <span className="slds-slider-label">
            <span className="slds-slider-label__range">
              {min} - {max} (Selected: {this.state.range[0]} -{' '}
              {this.state.range[1]})
            </span>
          </span>
        </span>
        <div className="slds-form-element__control">
          <div className="slds-slider">
            <input
              className="slds-slider__range range-slider original"
              type="range"
              value={this.state.original}
              min={min}
              max={max}
              onChange={(e, v) => this.handleSliderChange('original', e, v)}
            />
            <input
              className="slds-slider__range range-slider ghost"
              type="range"
              value={this.state.ghost}
              min={min}
              max={max}
              style={{
                '--low': `${((this.state.range[0] - min) / (max - min)) *
                  100}%`,
                '--high': `${((this.state.range[1] - min) / (max - min)) *
                  100}%`
              }}
              onChange={(e, v) => this.handleSliderChange('ghost', e, v)}
            />
          </div>
        </div>
      </div>
    );
  }
}

RangeSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  range: PropTypes.array,
  intl: intlShape.isRequired
};

export default injectIntl(RangeSlider);
